import mitt from 'mitt';

const emitter = mitt();

export const bus = {
  $on: emitter.on.bind(emitter),
  $off: emitter.off.bind(emitter),
  $emit: emitter.emit.bind(emitter),
};

export default bus;
